import ArticulationGame from './articulation/ArticulationGame';

export const gameRegistry = {
  'open-close-mouth': {
    title: 'Открой рот',
    View: ArticulationGame,
    exerciseConfig: {
      title: 'Открой рот',
      slug: 'open-close-mouth',
      neuralNetId: 1,
      dbId: 2,
      cvUrl: 'https://dev.cv.ezspeech.app/offer',
      maskInfo: { "use_mask": 1, "key_mask": "dog_ears" },
      videoTransform: "mask",
      maxReps: 10
    }
  },
  'show-teeth': {
    title: 'Заборчик',
    View: ArticulationGame,
    exerciseConfig: {
      title: 'Заборчик',
      slug: 'show-teeth',
      neuralNetId: 12,
      dbId: 17,
      cvUrl: 'https://dev.cv.ezspeech.app/offer',
      maskInfo: { "use_mask": 0, "key_mask": "none" },
      videoTransform: "none",
      maxReps: 10
    }
  },
  'brows-up': {
    title: 'Удивись',
    View: ArticulationGame,
    exerciseConfig: {
      title: 'Удивись',
      slug: 'brows-up',
      // neuralNetId — это id упражнения в фабрике CV-модуля, dbId — id в
      // его базе. Здесь они стояли наоборот, из-за чего CV-сервер получал
      // exercise_id 136, которого в фабрике нет вовсе, и соединение
      // навсегда зависало на «Ожидание сервера». Правильная пара видна в
      // unit_tests/test_brows_up_track.py: exerciseId=21, db_exercise_id=136.
      neuralNetId: 21,
      dbId: 136,
      cvUrl: 'https://dev.cv.ezspeech.app/offer',
      maskInfo: { "use_mask": 1, "key_mask": "dog_ears" },
      videoTransform: "mask",
      maxReps: 10
    }
  },
  'smiley-face': {
    title: 'Улыбка',
    View: ArticulationGame,
    exerciseConfig: {
      title: 'Улыбка',
      slug: 'smiley-face',
      neuralNetId: 2,
      dbId: 3,
      cvUrl: 'https://dev.cv.ezspeech.app/offer',
      maskInfo: { "use_mask": 0, "key_mask": "none" },
      videoTransform: "none",
      maxReps: 10
    }
  },
'kisses': {
    title: 'Поцелуйчик',
    View: ArticulationGame,
    exerciseConfig: {
      title: 'Поцелуйчик',
      slug: 'kisses',
      neuralNetId: 6,
      dbId: 1,
      cvUrl: 'https://dev.cv.ezspeech.app/offer',
      maskInfo: { "use_mask": 0, "key_mask": "none" },
      videoTransform: "none",
      maxReps: 10
    }
  },
'round-lips': {
    title: 'Слоник',
    View: ArticulationGame,
    exerciseConfig: {
      title: 'Слоник',
      slug: 'round-lips',
      neuralNetId: 3,
      dbId: 4,
      cvUrl: 'https://dev.cv.ezspeech.app/offer',
      maskInfo: { "use_mask": 0, "key_mask": "none" },
      videoTransform: "none",
      maxReps: 10
    }
  }
};